/* global axios */
import ApiClient from './ApiClient';

class StickerFavoritesAPI extends ApiClient {
  constructor() {
    super('sticker_favorites', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  saveFromAttachment(attachmentId, name = '') {
    return axios.post(this.url, {
      attachment_id: attachmentId,
      name,
    });
  }

  upload(file, name = '') {
    const formData = new FormData();
    formData.append('file', file);
    if (name) formData.append('name', name);
    return axios.post(this.url, formData);
  }

  check(attachmentId) {
    return axios.get(`${this.url}/check`, {
      params: { attachment_id: attachmentId },
    });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new StickerFavoritesAPI();
